/* eslint camelcase: 0 */
import { toOrderProps } from '../Monitaro/translator/order'
import { GmoGatewayBase } from './base'
import { GetLinkplusUrlMember, SearchCard, ExecTranCvs, CvsCancel, EntryTran, ExecTran } from '@/infrastructure/network/Gmo/requests/payment'

export default class Payment extends GmoGatewayBase {
  async GetLinkplusUrlMember(params: any) {
    return await this.apiClient.request(new GetLinkplusUrlMember(params))
  }

  async SearchCard() {
    return await this.apiClient.request(new SearchCard())
  }

  async EntryTran(id: string) {
    const response = await this.apiClient.request(new EntryTran(id))
    return response
  }

  async ExecTran(id: string) {
    const response = await this.apiClient.request(new ExecTran(id))
    return response
  }

  async ExecTranCvs(id: string, code: string) {
    const { order } = await this.apiClient.request(new ExecTranCvs(id, code))
    return toOrderProps(order)
  }

  async CvsCancel(id: string) {
    const { order } = await this.apiClient.request(new CvsCancel(id))
    return toOrderProps(order)
  }
}
